module.exports = __webpack_public_path__ + "img/arrow_up.4b1f80fd.svg";